<template>
  <v-container fluid grid-list-xs>
    <v-card>
      <v-card-text>
        <v-layout v-if="!editMode" align-center row wrap>
          <v-flex xs2 class="primary--text pa-1 font-weight-black">Name:</v-flex>
          <v-flex xs10 class="pa-1">{{ billing.name || '-' }}</v-flex>

          <v-flex xs2 class="primary--text pa-1 font-weight-black">Email:</v-flex>
          <v-flex xs10 class="pa-1">{{ billing.email || '-' }}</v-flex>

          <v-flex xs2 class="primary--text pa-1 font-weight-black">Phone:</v-flex>
          <v-flex xs10 class="pa-1">{{ billing.phone || '-' }}</v-flex>

          <v-flex xs2 class="primary--text pa-1 font-weight-black">Address:</v-flex>
          <v-flex xs10 class="pa-1"><span>{{ formattedAddress || '-' }}</span></v-flex>

          <v-flex v-if="canEdit" xs12 class="text-xs-right pa-1">
            <v-btn small flat color="primary" @click="startEdit">
              <v-icon small left>fa-pencil</v-icon>
              Edit
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout v-else row wrap>
          <v-flex xs12 sm6 px-2>
            <v-text-field label="Name" v-model.trim="draft.name" box></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 px-2>
            <v-text-field
              label="Email"
              v-model.trim="draft.email"
              :rules="emailRules"
              placeholder="email@example.com, another@example.com"
              hint="Separate multiple addresses with commas"
              persistent-hint
              box
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 px-2>
            <v-text-field label="Phone" v-model.trim="draft.phone" box></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 px-2>
            <v-text-field label="Street" v-model.trim="draft.address" box></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 px-2>
            <v-text-field label="City" v-model.trim="draft.city" box></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 px-2>
            <v-text-field label="State" v-model.trim="draft.state" box></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 px-2>
            <v-text-field label="Postal Code" v-model.trim="draft.postal_code" box></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 px-2>
            <v-text-field label="Country" v-model.trim="draft.country" box></v-text-field>
          </v-flex>

          <v-flex xs12 class="text-xs-right pa-1">
            <v-btn small flat color="error" :disabled="saving" @click="cancelEdit">
              <v-icon small left>fa-times</v-icon>
              Cancel
            </v-btn>
            <v-btn small color="primary" :disabled="saving || !isEmailValid" @click="save">
              Save
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin],

  props: {
    billing: Object
  },

  data () {
    return {
      editMode: false,
      saving: false,
      draft: {
        name: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        postal_code: '',
        country: ''
      },
      emailRules: [
        (v) => {
          const list = this.parseEmailList(v)
          return list.length === 0 || list.every(e => /.+@.+/.test(e)) || 'Each address must be valid; separate with commas'
        }
      ]
    }
  },

  computed: {
    canEdit () {
      return this.hasPermission('can_edit_billings')
    },
    isEmailValid () {
      const list = this.parseEmailList(this.draft.email)
      return list.length === 0 || list.every(e => /.+@.+/.test(e))
    },
    formattedAddress () {
      let address = ''
      let fields = [
        this.billing.address,
        this.billing.city,
        this.billing.state,
        this.billing.postal_code,
        this.billing.country
      ]

      for (let field of fields) {
        if (field) {
          address += field + ', '
        }
      }

      return address.slice(0, -2)
    }
  },

  methods: {
    parseEmailList (raw) {
      return raw ? String(raw).split(',').map(s => s.trim()).filter(Boolean) : []
    },
    startEdit () {
      this.draft = {
        name: this.billing.name || '',
        email: this.billing.email || '',
        phone: this.billing.phone || '',
        address: this.billing.address || '',
        city: this.billing.city || '',
        state: this.billing.state || '',
        postal_code: this.billing.postal_code || '',
        country: this.billing.country || ''
      }
      this.editMode = true
    },
    cancelEdit () {
      this.editMode = false
    },
    buildPayload () {
      const payload = {}
      const fields = ['name', 'phone', 'address', 'city', 'state', 'postal_code', 'country']

      for (let field of fields) {
        const value = (this.draft[field] || '').trim()
        if (value !== (this.billing[field] || '')) {
          payload[field] = value
        }
      }

      const newEmail = this.parseEmailList(this.draft.email).join(', ')
      if (newEmail && newEmail !== (this.billing.email || '')) {
        payload.email = newEmail
      }

      return payload
    },
    async save () {
      if (!this.isEmailValid || this.saving) {
        return
      }

      const payload = this.buildPayload()
      if (Object.keys(payload).length === 0) {
        this.cancelEdit()
        return
      }

      this.saving = true
      Bus.$emit('openWaitModal')

      try {
        let result = await this.api({
          method: 'put',
          url: `/billings/${this.billing.id}`,
          data: payload
        })

        this.$emit('updated', result.data.billing)
        this.editMode = false
      } catch (err) {
        Bus.$emit('openModal', { status: 'error', message: err })
      } finally {
        this.saving = false
        Bus.$emit('closeWaitModal')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/terminal/components/BillingCard.vue